import { Box, Spinner } from '@shopify/polaris';

const Loading = () => {
  return (
    <Box
      padding="200"
      background="bg-transparent"
      width="100%"
    >
      <Spinner
        accessibilityLabel="loading"
        size="small"
      />
    </Box>
  );
};

export const InlineSpinner = () => (
  <span style={{ display: 'flex', '--p-color-bg-fill-brand': 'currentColor' }}>
    <Spinner
      accessibilityLabel="loading"
      size="small"
    />
  </span>
);

export default Loading;
